<template>
  <div class="row">
    <div class="col-12">
      <b-button
        variant="success"
        v-if="$props.data.url"
        :href="$props.data.url"
        target="_blank"
        size="sm"
      >
        <b-icon-map class="mr-2"></b-icon-map>
        Voir la tournée sur Google Maps
      </b-button>
      <b-button @click="printDocuments()" variant="info" class="ml-3" size="sm">
        <b-icon-printer-fill class="mr-2"></b-icon-printer-fill>
        Imprimer le dossier
      </b-button>
      <b-button v-if="id == null" @click="saveRoute()" variant="secondary" class="ml-3" size="sm">
        <b-icon-upload class="mr-2"></b-icon-upload>
        Sauvegarder la tournée
      </b-button>
      <b-button v-else variant="secondary" @click="saveRoute()" size="sm" class="ml-3">
        <b-icon-upload class="mr-2"></b-icon-upload>
        Mettre à jour la tournée (#{{id}})
      </b-button>
    </div>
    <div class="col-12 mt-3" v-if="$props.data.warnings.length > 0">
      <b-alert show variant="danger">
        <h6 class="alert-heading">Attention!</h6>
        <div v-for="(warning, i) in $props.data.warnings" :key="i">
          <p v-html="warning"></p>
        </div>
      </b-alert>
    </div>
    <div class="col-12 mt-3">
      <table class="table table-striped table-hover">
        <thead>
          <tr>
            <th></th>
            <th class="text-center">Étape</th>
            <th>Adresse</th>
            <th>Débiteur</th>
            <th class="text-center">N° de mandat</th>
            <th class="text-center">Avis de passage</th>
            <th class="text-center">Document négo</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(waypoint, j) in ways" :key="j">
            <td class="text-center"><b-button @click="suppressWaypoint(j)" v-if="j > 0" size="xs" variant="danger"><i class="fad fa-times"></i></b-button></td>
            <td class="text-center">{{ waypoint.index }}</td>
            <td>{{ waypoint.address }}</td>
            <td>{{ waypoint.debiteur }}</td>
            <td class="text-center">{{ waypoint.mandat }}</td>
            <td class="text-center">
              <b-checkbox v-if="j != 0" v-model="ways[j].doc_nego"></b-checkbox>
            </td>
            <td class="text-center">
              <b-checkbox
                v-if="j != 0"
                v-model="ways[j].avis_passage"
              ></b-checkbox>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <iframe
      :key="renderMap"
      class="col-12"
      frameborder="0"
      style="border: 0"
      height="500"
      referrerpolicy="no-referrer-when-downgrade"
      :src="gdata.api_url"
      allowfullscreen
    >
    </iframe>
  </div>
</template>

<script>
import warrants from "@/services/warrants";
export default {
  name: "GoogleRoute",
  props: {
    data: Object,
  },
  data() {
    return {
      ways: [],
      id: null,
      gdata: {},
      renderMap: 0
    };
  },
  created() {
    this.gdata = this.$props.data;
    if(this.gdata.id) {
      this.id = this.gdata.id
    }
    this.gdata.waypoints.forEach((el, i) => {
      if (i == 0) {
        this.ways.push({
          index: i,
          mandat: null,
          address: el,
          debiteur: null,
          doc_nego: null,
          avis_passage: null,
        });
      } else {
        this.ways.push({
          index: i,
          mandat: this.$props.data.mandats[i - 1],
          address: el,
          debiteur: this.$props.data.debiteurs[i - 1],
          doc_nego: true,
          avis_passage: true,
        });
      }
    });
  },
  methods: {
    suppressWaypoint(j) {
      this.gdata.mandats.splice(j - 1,1);
      let ids = this.gdata.mandats;
      this.ways.splice(j, 1)
      warrants
        .routes({
          nego: this.$store.getters.getKeycloak.me.ID,
          ids: ids,
        })
        .then((response) => {
          if (response.data && response.data.url) {
            this.gdata = response.data;
            this.renderMap++;
          }
        });
    },
    saveRoute() {
      if(this.id) {
        this.gdata.id = this.id;
      }
      warrants.save_route(this.gdata).then((response) => {
        if (response.data.success) {
          this.id = response.data.ID;
          this.$bvToast.toast("Tournée enregistrée", {
            title: `Recuperator`,
            toaster: "b-toaster-top-right",
            variant: "success",
            autoHideDelay: 2000,
            solid: false,
          });
        }
      });
    },
    printDocuments() {
      warrants
        .print_dossier_nego({
          ways: this.ways,
        })
        .then((response) => {
          this.busy = false;
          if (response.data.success) {
            window.open(
              this.$store.getters.url +
                "/upload/documents/md/" +
                response.data.pdf,
              "_blank"
            );
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>